import { LANGUAGES } from "@lyteflo/types";
import { isLocalDev } from "@utils/environment";

/**
 * Initializes the manifest based on the current language.
 * Should be called after i18n is initialized.
 */
export const initializeManifest = () => {
  if (isLocalDev) {
    return;
  }

  // Check localStorage first (i18n preference), then navigator language
  const storedLang = localStorage.getItem("lf_language");
  const navigatorLang = navigator.language || LANGUAGES.EN;

  let currentLang = storedLang || navigatorLang;

  // Ensure we have a valid language code
  if (currentLang.startsWith("fr")) {
    currentLang = LANGUAGES.FR;
  } else {
    currentLang = LANGUAGES.EN;
  }

  // Remove existing manifest link
  const existing = document.querySelector('link[rel="manifest"]');
  if (existing) existing.parentNode?.removeChild(existing);

  // Create manifest link based on language
  const manifestLink = document.createElement("link");
  manifestLink.rel = "manifest";

  if (currentLang === LANGUAGES.FR) {
    manifestLink.href = "/assets/pwa/manifest.fr.webmanifest";
  } else {
    manifestLink.href = "/assets/pwa/manifest.en.webmanifest";
  }

  document.head.appendChild(manifestLink);
};
